module.exports = __webpack_public_path__ + "img/red_002.0dcf1dd5.png";